import { createSelector } from 'reselect';
import { rootSelector } from '../selectors';

/**
 * Returns Sso data needed for setup.
 */
export const getPreSsoConnectionInfo = createSelector(
  rootSelector,
  settings => settings.sso.preSsoConnectionInfo.data,
);

/**
 * Returns Sso settings.
 */
export const getSsoSettings = createSelector(
  rootSelector,
  settings => settings.sso.ssoSettings.data,
);

/**
 * Gets whether the sso settings have loaded.
 * If Sso is not configured, sso settings will never get loaded.
 */
export const getSsoSettingsHaveLoaded = createSelector(rootSelector, settings => {
  const { requested, loading, data } = settings.sso.ssoSettings;
  return !!data || (requested && !loading);
});
